import { useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTutorial } from '../../context/TutorialContext';
import { onboardingTutorial } from '../../config/tutorials';

/**
 * TutorialTrigger component
 * Automatically starts the onboarding tutorial for new users after they sign up
 */
export const TutorialTrigger: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const { startTutorial, hasCompletedTutorial } = useTutorial();
  const hasTriggered = useRef(false);

  useEffect(() => {
    // Only trigger once per session
    if (hasTriggered.current) return;

    // Check if user just logged in and hasn't completed the tutorial
    if (isAuthenticated && user) {
      const hasCompleted = hasCompletedTutorial(onboardingTutorial.id);
      
      // Check if this is a new user (created recently - within last 5 minutes)
      const isNewUser = user.createdAt && 
        new Date().getTime() - new Date(user.createdAt).getTime() < 5 * 60 * 1000;

      // Start tutorial if:
      // 1. User is new (created within last 5 minutes), OR
      // 2. User hasn't completed the tutorial before
      if (isNewUser || !hasCompleted) {
        // Wait a bit for the UI to settle before starting
        const timer = setTimeout(() => {
          startTutorial(onboardingTutorial);
          hasTriggered.current = true;
        }, 1500);

        return () => clearTimeout(timer);
      }
    }
  }, [isAuthenticated, user, startTutorial, hasCompletedTutorial]);

  return null; // This component doesn't render anything
};



